<script>
import SourceRatings from "@/components/source-ratings";
import dayjs         from "dayjs";

export default{
  data () {
    return {
      start_date: null
    }
  },
  props: ['end_date', 'settings', 'company_id', 'group_id'],
  components: { SourceRatings },
  beforeMount () {
    if (this.settings.n_periods) this.start_date = dayjs(this.end_date).add(-1 * ((this.settings.n_periods || 1) -1), this.settings.period).format("YYYY-MM-DD")
  }
}
</script>

<template>
  <div>
    <source-ratings
      :start_date='start_date' :end_date='end_date'
      :settings='settings' :company_id='company_id'
      :hideProperty=true :sortable='false'
      v-if=start_date
      />
  </div>
</template>
